module.exports = __webpack_public_path__ + "static/media/MiSensorsLogo.2ab37496.svg";